/*
@module logger
@desc 日志模块，用于整个程序运行过程中打出的日志（log,warn,error,deprecate等类型）
*/
// 默认的logger模块，browser的window.console和nodejs的global.console
const consoleLogger = {
  type: 'logger',

  // console.log
  log(args) {
    this.output('log', args);
  },

  // console.warn
  warn(args) {
    this.output('warn', args);
  },

  // console.error
  error(args) {
    this.output('error', args);
  },

  // 统一调用log，warn，error
  output(type, args) {
    /* eslint no-console: 0 */
    // browser and nodejs support OK
    if (console && console[type]) console[type](...args);
  }

}; // Logger类

class Logger {
  constructor(concreteLogger, options = {}) {
    this.init(concreteLogger, options);
  }

  init(concreteLogger, options = {}) {
    // 打log的前缀
    this.prefix = options.prefix || 'ti18n:'; // 如果有传入自定义logger，就用，如果没有，就用默认的consoleLogger

    this.logger = concreteLogger || consoleLogger; // 参数

    this.options = options; // 是否调试状态

    this.debug = options.debug;
  } // 设置调试状态


  setDebug(bool) {
    this.debug = bool;
  } // log级别,只在debug状态下执行


  log(...args) {
    return this.forward(args, 'log', '', true);
  } // warn级别，只在debug状态下执行


  warn(...args) {
    return this.forward(args, 'warn', '', true);
  } // error级别，任何状态下都执行


  error(...args) {
    return this.forward(args, 'error', '');
  } // deprecate级别，表示不推荐/废弃的标准和用法，只在debug状态下执行


  deprecate(...args) {
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  } // 统一调用

  /*
  @param {array} args 透传给log的参数
  @param {string} lvl 日志级别，比如：log。warn。error等
  @param {string} prefix 日志前缀
  @param {boolean} debugOnly 是否只在debug状态下生效
  */


  forward(_args, lvl, prefix, debugOnly) {
    const args = _args;
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  } // 创建一个指定模块子前缀的Logger，在主前缀的后面 prefix:moduleName


  create(moduleName) {
    return new Logger(this.logger, { ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }

}

var baseLogger = new Logger();

// 定义为一个类
class EventEmitter {
  constructor() {
    // 构造函数，初始化成员observers
    // observers存储类所有事件的名称，状态，监听函数队列等信息
    this.observers = {};
  } // 为一个或多个事件类型建立监听事件,类似于addEventListener
  // {string} events ,如果为多个事件 空格隔开
  // {function} listener 事件触发后调用的函数


  on(events, listener) {
    events.split(' ').forEach(event => {
      this.observers[event] = this.observers[event] || [];
      this.observers[event].push(listener);
    });
    return this;
  } // 移除已经建立的监听事件，类似于removeEventListener


  off(event, listener) {
    if (!this.observers[event]) return; // 如果没有指定具体的listener，则移除该事件类型下的所有监听事件

    if (!listener) {
      delete this.observers[event];
      return;
    } // 如果指定了listener,则移除指定的listener


    this.observers[event] = this.observers[event].filter(l => l !== listener);
  } // 触发一个事件
  // {string} event,要触发的事件名
  // {...args} 附加数据，用于透传到事件listener中，供listener使用


  emit(event, ...args) {
    if (this.observers[event]) {
      const cloned = [].concat(this.observers[event]);
      cloned.forEach(observer => {
        observer(...args);
      });
    } // 如果指定了*这个事件，那么所有的事件类型的触发都将通知到它的listener


    if (this.observers['*']) {
      const cloned = [].concat(this.observers['*']);
      cloned.forEach(observer => {
        observer.apply(observer, [event, ...args]);
      });
    }
  }

}

function defer() {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object === null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, _t) {
  const t = _t;
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(_object, path, Empty) {
  let object = _object;

  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    const key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  const value = getPath(data, key);

  if (value !== undefined) {
    return value;
  } // Fallback to default values


  return getPath(defaultData, key);
}
function deepExtend(_target, source, overwrite) {
  const target = _target;
  /* eslint no-restricted-syntax: 0 */

  for (const prop in source) {
    if (prop in target) {
      /*
        If we reached a leaf string in target or source then
        replace with source or skip depending on the 'overwrite' switch
      */
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }

  return data;
}
const isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1; // 获取一个value的路径

function getKeyPathByValue(_data, value) {
  const data = _data;

  function getKeyPathArrByValue(_data, value, _arrKeyPath = []) {
    let data = _data;
    let arrKeyPath = _arrKeyPath;
    arrKeyPath = arrKeyPath.slice(0);

    if (data === value) {
      return arrKeyPath;
    }

    if ('object' === typeof data) {
      data = { ...data
      };

      for (const k in data) {
        const arrKeyPathTmp = [...arrKeyPath];
        const subData = data[k];
        arrKeyPathTmp.push(k);
        const res = getKeyPathArrByValue(subData, value, arrKeyPathTmp);

        if (res) {
          return res;
        }
      }
    } else {
      return false;
    }
  }

  const arrPath = getKeyPathArrByValue(data, value);

  if (arrPath && arrPath instanceof Array && arrPath.length) {
    return arrPath.join('.');
  }

  return '';
}

/*
资源管理器
*/

class ResourceStore extends EventEmitter {
  // 构造函数

  /*
  data 为原始数据(lng-ns-key的分级形式)
  */
  constructor(data, options = {
    ns: ['translation'],
    defaultNS: 'translation'
  }) {
    super();

    if (isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    }

    this.data = data || {};
    this.options = options;

    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
  } // 添加命名空间


  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  } // 移除命名空间


  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);

    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  } // 获取资源


  getResource(lng, ns, key, options = {}) {
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    } // 调用utils.getPath获取资源


    return getPath(this.data, path);
  } // 添加资源，单个key-value的形式，options中的silent表示是否静默添加，如果为true，表示不触发添加事件


  addResource(lng, _ns, key, _value, options = {
    silent: false
  }) {
    let ns = _ns;
    let value = _value;
    let {
      keySeparator
    } = this.options;
    if (keySeparator === undefined) keySeparator = '.';
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key); // 如果用第一个参数是.链接的，那么第一个参数是融合了lng.ns.key的

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      [ns] = path;
    } // 首先确保namespace已经添加


    this.addNamespaces(ns); // 为指定path，设置指定的值

    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  } // 添加一个object类型的resource，里面包括多个key-value


  addResources(lng, ns, resources, options = {
    silent: false
  }) {
    /* eslint no-restricted-syntax: 0 */
    for (const m in resources) {
      // key:m  value:resources[m]
      if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }

    if (!options.silent) this.emit('added', lng, ns, resources);
  } // 添加某一个lng-ns 下的资源


  addResourceBundle(lng, _ns, _resources, _deep, overwrite, options = {
    silent: false
  }) {
    let deep = _deep;
    let ns = _ns;
    let resources = _resources;
    let path = [lng, ns]; // [lng,ns]可以简单用第一个参数代替：比如：'en.pageA' = ['en','pageA'],其中，lng='en'  ns='pageA'

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      [, ns] = path;
    } // 保证nsmespace添加上


    this.addNamespaces(ns); // 获取当前路径上的数据

    let pack = getPath(this.data, path) || {}; // deep表示深拷贝，overwrite表示是否属性覆盖，如果是，则直接覆盖，如果不是，则执行递归拷贝（有子属性的情况下）

    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      // 浅拷贝
      pack = { ...pack,
        ...resources
      };
    } // 将最终数据set到对应的路径上


    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  } // 移除指定lng-ns上的数据


  removeResourceBundle(lng, _ns) {
    const ns = _ns;

    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    } // 移除命名空间


    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  } // 判断是否存在指定的lng-ns数据


  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  } // 获取指定lng，ns的bundle数据


  getResourceBundle(lng, _ns) {
    let ns = _ns;
    if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

    if (this.options.compatibilityAPI === 'v1') return { ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  } // 获取指定语言lng下的所有ns的数据


  getDataByLanguage(lng) {
    return this.data[lng];
  } // 返回所有数据


  toJSON() {
    return this.data;
  }

}

/*
链式处理器
需要在ti18n实例化的时候：
use(processModule);

其中processModule的type=postProcess
processModule的name必须定义，且必须唯一
*/
var postProcessor = {
  processors: {},

  addPostProcessor(module) {
    this.processors[module.name] = module;
  },

  handle(processors, _value, key, options, translator) {
    let value = _value; // 链式处理，调用

    processors.forEach(processor => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }

};

/*
@module Translator
@desc 核心转换层
*/
const checkedLoadedFor = {};

class Translator extends EventEmitter {
  constructor(services, options = {}) {
    super();

    if (isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    } // 将services中的指定服务复制到this中，方便调用


    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'dateResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;

    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }

    if (!this.options.keyFromOptions) {
      this.options.keyFromOptions = {
        keyFrom: 'key'
      };
    }

    this.logger = baseLogger.create('translator');
  }

  changeLanguage(lng) {
    if (lng) this.language = lng;
  }

  exists(key, options = {
    interpolation: {}
  }) {
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  } // 从一个简写的字符串key中，分离出ns和key


  extractFromKey(_key, options) {
    let key = _key; // ns分隔符

    let nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':'; // key分隔符

    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS;

    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      const parts = key.split(nsSeparator);

      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) {
        // 如果ns分隔符和key分隔符不同，或者第一个元素为ns，那么就取第一个元素作为当前的ns
        namespaces = parts.shift();
      } // key就是除了ns之外的元素用keySeperator链接起来的一个string


      key = parts.join(keySeparator);
    }

    if (typeof namespaces === 'string') namespaces = [namespaces];
    return {
      key,
      namespaces
    };
  } // 核心翻译转换函数


  translate(_keys, _options) {
    let keys = _keys;
    let options = _options; // 参数重载

    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    } // options默认为{}


    if (!options) options = {}; // 如果keys为空、null、undefined，那么转换为空字符串

    if (keys === undefined || keys === null
    /* || keys === ''*/
    ) return ''; // 如果keys不是一个数组，那么转换成数组形式

    if (!Array.isArray(keys)) keys = [String(keys)]; // key分隔符

    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // 分离出ns,key

    let {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    namespaces = namespaces.concat(); // 取数组中的最后一个ns作为ns

    const namespace = namespaces[namespaces.length - 1]; // 获取真实key，因为可能key是word

    keys = this.getRealKeys(keys, namespace);
    [key] = keys; // return key on CIMode

    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

    if (lng && lng.toLowerCase() === 'cimode') {
      // cimode下直接返回key
      if (appendNamespaceToCIMode) {
        // 如果需要加上ns，则在key前面加上ns
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    } // resolve from store


    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject; // 是否当作对象处理

    const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number'; // res当作对象处理

    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        // 处理一个object的时候，却遇到options指明不返回object，矛盾！抛出warning
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : `key '${key} (${this.language})' returned an object instead of string.`;
      } // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values


      if (keySeparator) {
        const resTypeIsArray = resType === '[object Array]';
        const copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */

        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

        for (const m in res) {
          // 自有属性
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`; // 递归调用

            copy$$1[m] = this.translate(deepKey, { ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }

        res = copy$$1;
      }
    } else if ( // 当作数组处理
    handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // 当作字符串、empty或者null处理
      // string, empty or null
      let usedDefault = false;
      let usedKey = false; // 默认值

      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true; // 复数处理

        if (options.count !== undefined) {
          // 获取指定lng的复数后缀
          const suffix = this.pluralResolver.getSuffix(lng, options.count);
          res = options[`defaultValue${suffix}`];
        }

        if (!res) res = options.defaultValue;
      }

      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      } // save missing


      const updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        } // 处理missing的key


        const send = (l, k) => {
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            // 保存缺失的key-value到后端
            this.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } // 触发missingKey事件，表示missing了某个key


          this.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          // 是否需要处理复数
          const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(l => {
              // 获取指定key的复数形式的key
              const plurals = this.pluralResolver.getPluralFormsOfKey(l, key);
              plurals.forEach(p => send([l], p));
            });
          } else {
            send(lngs, key);
          }
        }
      } // extend，执行额外的操作，保证第三方插件和一些插值逻辑、nesting逻辑，第三方Processor逻辑被执行


      res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key
      // 对于missing 的key的处理，是否在前面加上ns

      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`; // parseMissingKeyHandler

      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    } // return


    return res;
  }

  extendTranslation(_res, key, options, resolved) {
    let res = _res;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      // 需要处理插值逻辑
      // ti18n.parsing
      if (options.interpolation) this.interpolator.init({ ...options,
        ...{
          interpolation: { ...this.options.interpolation,
            ...options.interpolation
          }
        }
      }); // interpolate 处理插值

      let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;

      if (this.options.interpolation.defaultVariables) {
        data = { ...this.options.interpolation.defaultVariables,
          ...data
        };
      }

      res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting 处理nesting

      if (options.nest !== false) res = this.interpolator.nest(res, (...args) => this.translate(...args), options);
      if (options.interpolation) this.interpolator.reset();
    } // 处理第三方的PostProcessor调用


    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: resolved,
        ...options
      } : options, this);
    }

    return res;
  } // 处理指定keys的转换


  resolve(_keys, options = {}) {
    let keys = _keys;
    let found;
    let usedKey; // plain key,普通key

    let exactUsedKey; // key with context / plural，带上下文或者复数形式的key

    let usedLng;
    let usedNS;
    if (typeof keys === 'string') keys = [keys]; // 遍历每个key

    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const {
        key
      } = extracted;
      usedKey = key;
      let {
        namespaces
      } = extracted;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS); // 是否需要处理复数

      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string'; // 是否需要处理上下文

      const needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== ''; // 获取标准语言格式

      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng); // 遍历每个ns

      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns; // ns还未加载，报错

        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for namespace "${usedNS}" for languages "${codes.join(', ')}" won't get resolved as namespace was not yet loaded`, 'This means something IS WRONG in your application setup. You access the t function before ti18n.init / ti18n.loadNamespace / ti18n.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        } // 遍历ns下的每个语言


        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          let finalKey = key;
          const finalKeys = [finalKey];

          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

            if (needsContextHandling) finalKeys.push(finalKey += `${this.options.contextSeparator}${options.context}`); // get key for plural if needed

            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


          let possibleKey;
          /* eslint no-cond-assign: 0 */

          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  } // 判断是否合法的转换结果


  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  } // 获取资源，如果有i18nFormat.getResource 则用i18nFormat.getResource 代替 resourceStore.getResource


  getResource(code, ns, key, options = {}) {
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  } // 更改keyFromOptions


  changeKeyFrom(keyFromOptions) {
    let keyFrom = '';
    let wordLng = '';

    if ('string' === typeof keyFromOptions) {
      keyFrom = keyFromOptions;
    } else if ('object' === typeof keyFromOptions) {
      keyFrom = keyFromOptions.keyFrom;
      wordLng = keyFromOptions.wordLng;
    } else {
      this.wran('changeKeyFrom请传入有效的参数~');
      return;
    }

    if (/^(key|word)$/.test(keyFrom)) {
      this.options.keyFromOptions.keyFrom = keyFrom;

      if ('word' === keyFrom && wordLng) {
        this.options.keyFromOptions.wordLng = wordLng;
      }

      if ('word' === this.options.keyFromOptions.keyFrom && !this.options.keyFromOptions.wordLng) {
        this.options.keyFromOptions.wordLng = this.options.fallbackLng && this.options.fallbackLng[0];
      }

      this.emit('changeKeyFrom', { ...this.options.keyFromOptions
      });
    }
  } // 获取真实的key,因为当keyFrom为word时，需要转换


  getRealKeys(arrKeys, ns = '') {
    const {
      keyFrom,
      wordLng
    } = this.options.keyFromOptions;

    if ('word' !== keyFrom) {
      return arrKeys;
    }

    return arrKeys.map(key => this.translateWord(key, {
      lng: wordLng,
      ns
    }));
  } // 通过词条查询key


  translateWord(word, options = {}) {
    const lng = options.lng || this.language;
    let ns = options.ns || this.options.ns || this.options.defaultNS;

    if (ns && 'string' === typeof ns) {
      ns = [ns];
    }

    const res = [];

    if ('undefined' === typeof word || '' === word) {
      this.logger.warn('the word to be translateWord  should be a string bug get \'\' or undefined');
      return;
    }

    if (!ns.length) {
      this.logger.warn(`ns should be an array bug get nothing while translateWord ${word}`);
      return;
    }

    if (!lng) {
      this.logger.warn(`can not get the value of lng while translateWord ${word}`);
      return;
    }

    ns.forEach(namespace => {
      if (!this.resourceStore.hasResourceBundle(lng, namespace)) {
        return;
      }

      const bundleData = this.resourceStore.getResourceBundle(lng, namespace);
      const key = getKeyPathByValue(bundleData, word);

      if (key) {
        res.push({
          ns: namespace,
          key
        });
      }
    });

    if (!res.length) {
      return '';
    }

    if (res.length === 1) {
      return res[0].key;
    }

    const oRes = {};
    res.forEach(t => {
      oRes[t.ns] = t.key;
    });
    return oRes;
  } // 日期翻译


  translateDate(date, config) {
    if (!config.language) {
      config.language = this.language;
    }

    return this.dateResolver.getResolvedDate(date, config);
  }

}

/*
  @module LanguageUtils
  @desc 语言处理和语言标准化，语言各部分分离，格式化等逻辑
  参考文档：http://www.iana.org/assignments/language-tags/language-tags.xhtml
  主要就是：
  一个标准的语言标记包括：语言-脚本-区域 三个子tag组成
  比如：
  zh-Hans-CN
  表示：language为zh中文
  script为Hans，简体
  region为CN表示在中国大陆使用
*/

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = baseLogger.create('languageUtils');
  } // 获取script部分


  getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  } // 获取language部分


  getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  } // 格式化


  formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      let p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(part => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  } // 是否在白名单列表中


  isWhitelisted(_code) {
    let code = _code;

    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }

    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  } // 获取回退语言标记


  getFallbackCodes(_fallbacks, _code) {
    let fallbacks = _fallbacks;
    const code = _code;
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
    if (!code) return fallbacks.default || []; // asume we have an object defining fallbacks

    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  } // 获取标准化的语言列表


  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];

    const addCode = c => {
      if (!c) return;

      if (this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting non-whitelisted language code: ${c}`);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }

}

class DateResolver {
  constructor(options = {}) {
    this.options = options;
    this.logger = baseLogger.create('dateResolver');
  }

  getDefaultFormat() {
    return {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    };
  }

  getResolvedDate(date, config) {
    const {
      language = 'en',
      type = 'long'
    } = config;
    const hasCustomFormat = this.options.dateTimeFormats && this.options.dateTimeFormats[language] && this.options.dateTimeFormats[language][type];
    const format = hasCustomFormat ? this.options.dateTimeFormats[language][type] : this.getDefaultFormat();
    const formatter = new Intl.DateTimeFormat(language, format);
    const result = formatter.format(date);
    return result;
  }

}

/* eslint-disable */

let sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he"],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: function (n) {
    return Number(n > 1);
  },
  2: function (n) {
    return Number(n != 1);
  },
  3: function (n) {
    return 0;
  },
  4: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function (n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function (n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function (n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function (n) {
    return Number(n >= 2);
  },
  10: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function (n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function (n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function (n) {
    return Number(n !== 0);
  },
  14: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function (n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function (n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function (n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function (n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function (n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  const rules = {};
  sets.forEach(set => {
    set.lngs.forEach(l => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

class PluralResolver {
  constructor(languageUtils, options = {}) {
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  addRule(lng, obj) {
    this.rules[lng] = obj;
  }

  getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }

  needsPlural(code) {
    const rule = this.getRule(code);
    return rule && rule.numbers.length > 1;
  }

  getPluralFormsOfKey(code, key) {
    const ret = [];
    const rule = this.getRule(code);
    if (!rule) return ret;
    rule.numbers.forEach(n => {
      const suffix = this.getSuffix(code, n);
      ret.push(`${key}${suffix}`);
    });
    return ret;
  }

  getSuffix(code, count) {
    const rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular
      const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      let suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString(); // COMPATIBILITY JSON
      // v1


      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
        return returnSuffix();
      }

      if (
      /* v2 */
      this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      }

      if (
      /* v3 - gettext index */
      this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn(`no plural rule found for: ${code}`);
    return '';
  }

}

/*
@module interpolator.js
@desc 插值相关逻辑
*/

class Interpolator {
  constructor(options = {}) {
    this.logger = baseLogger.create('interpolator');
    this.options = options; // format是一个函数类型，意为格式化

    this.format = options.interpolation && options.interpolation.format || (value => value); // 调用初始化函数


    this.init(options);
  }
  /* eslint no-param-reassign: 0 */


  init(options = {}) {
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const iOpts = options.interpolation; // escape表示转义方法，为了前端安全，一般为了防xss

    this.escape = iOpts.escape !== undefined ? iOpts.escape : escape; // 表示是否开启escape转义

    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false; // 插值前缀

    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{'; // 插值后缀

    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}'; // 分隔符

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ','; // 表示不参与转义的标识符前缀

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-'; // 表示不参与转义的标识符后缀

    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // 是否始终格式化

    this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false; // the regexp

    this.resetRegExp();
  }

  reset() {
    if (this.options) this.init(this.options);
  } // 根据最新的标识符，重置正则匹配规则


  resetRegExp() {
    // the regexp
    const regexpStr = `${this.prefix}(.+?)${this.suffix}`; // 匹配插值

    this.regexp = new RegExp(regexpStr, 'g');
    const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`; // 匹配不需要转义的插值

    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
    const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  } // 对插值变量进行转换


  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    } // 格式化


    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = getPathWithDefaults(data, defaultData, key);
        return this.alwaysFormat ? this.format(path, undefined, lng) : path;
      }

      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
    };

    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    replaces = 0; // unescape if has unescapePrefix/Suffix

    /* eslint no-cond-assign: 0 */

    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());

      if (value === undefined) {
        if (typeof missingInterpolationHandler === 'function') {
          const temp = missingInterpolationHandler(str, match, options);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn(`missed to pass in variable ${match[1]} for interpolating ${str}`);
          value = '';
        }
      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
        value = makeString(value);
      }

      str = str.replace(match[0], regexSafe(value));
      this.regexpUnescape.lastIndex = 0;
      replaces = replaces + 1;

      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0; // regular escape on demand

    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());

      if (value === undefined) {
        if (typeof missingInterpolationHandler === 'function') {
          const temp = missingInterpolationHandler(str, match, options);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn(`missed to pass in variable ${match[1]} for interpolating ${str}`);
          value = '';
        }
      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
        value = makeString(value);
      }

      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces = replaces + 1;

      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    return str;
  } // 转换出nesting的值，比如： 'marsboy,${boy,{"count":12}}'  => marsboy,has 12 boys    其中key：{"boy_plural":"{{count}} boys"}


  nest(str, fc, options = {}) {
    let match;
    let value;
    let clonedOptions = { ...options
    };
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    delete clonedOptions.defaultValue; // assert we do not get a endless loop on interpolating defaultValue
    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

    function handleHasOptions(key, inheritedOptions) {
      const sep = this.nestingOptionsSeparator; // 判断nesting里面是否有options,比如：key= girl,{count:2} 就是带options的nesting
      // 如果没有options分隔符，那么就是纯的key，直接返回key

      if (key.indexOf(sep) < 0) return key; // 如果带options，则把options提取出来

      const c = key.split(new RegExp(`${sep}[ ]*{`)); // 提取出来的options，如： {count:2}

      let optionsString = `{${c[1]}`; // 对应的key

      [key] = c;
      optionsString = this.interpolate(optionsString, clonedOptions); // 单引号换成双引号

      optionsString = optionsString.replace(/'/g, '"'); // 尝试转换optionsString=》object

      try {
        clonedOptions = JSON.parse(optionsString); // 是否使用继承

        if (inheritedOptions) clonedOptions = { ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        // 转换optionsString=》object失败
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      } // assert we do not get a endless loop on interpolating defaultValue again and again


      delete clonedOptions.defaultValue;
      return key;
    } // regular escape on demand


    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      /**
       * If there is more than one parameter (contains the format separator). E.g.:
       *   - t(a, b)
       *   - t(a, b, c)
       *
       * And those parameters are not dynamic values (parameters do not include curly braces). E.g.:
       *   - Not t(a, { "key": "{{variable}}" })
       *   - Not t(a, b, {"keyA": "valueA", "keyB": "valueB"})
       */

      let doReduce = false; // 包括,但是不包括附加参数{}

      if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
        [match[1], ...formatters] = match[1].split(this.formatSeparator).map(elem => elem.trim());
        doReduce = true;
      } // fc函数根据nesting的key，和 options计算出值


      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

      if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

      if (typeof value !== 'string') value = makeString(value); // 转换指定的key的时候，丢失，抛出异常

      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }

      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, options), value.trim());
      } // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      // 用value替换整个匹配到的nesting


      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }

    return str;
  }

}

/*
  @module ResourceConnector.js
  @desc 资源连接器，用于获取资源的中间层，向上可扩展为后端连接器（BackendConnector）和缓存连接器（CacheConnector）
*/

function remove(arr, what) {
  let found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}
/*
@class Connector
@desc 定义连接器类
*/


class Connector extends EventEmitter {
  constructor(connectorInstance, store, services, options) {
    super();

    if (isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    } // 赋值


    this.connectorInstance = connectorInstance; // 后端请求相关实例封装

    this.store = store; // 资源管理ResourceStore

    this.services = services; // 服务相关

    this.languageUtils = services.languageUtils; // 语言相关处理

    this.options = options; // ti18n的配置

    this.connectorType = options.connectorType;
    this.logger = baseLogger.create(this.connectorType);
    this.state = {}; // 状态

    this.queue = []; // 队列
    // 如果backend有初始化函数，则初始化

    /* if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }*/
  } // 获取最新的必要的资源加载队列


  queueLoad(languages, namespaces, options, callback) {
    // find what needs to be loaded
    const toLoad = []; // 要加载的数据列表

    const pending = []; // 正在加载还未返回结果的数据列表

    const toLoadLanguages = []; // 需要加载的语言列表

    const toLoadNamespaces = []; // 需要加载的ns列表
    // 遍历语言

    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        // name为 lng|ns 结构的key
        const name = `${lng}|${ns}`; // 如果store中已经有值，并且不需要realod

        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2; // loaded
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          // pending中，还未返回
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          // 设置为pending
          this.state[name] = 1; // pending
          // 加入到pending，并且设置hasAllNamespaces为false，表示还有ns待加载到队列中

          hasAllNamespaces = false;
          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name); // 加入到ns队列中

          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      }); // 当前语言中还有ns未加载，故当前语言加入到toLoad中

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    }); // 如果有还未加载完成的资源，则加入到queue队列中

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending,
        loaded: {},
        errors: [],
        callback
      });
    }

    return {
      toLoad,
      pending,
      toLoadLanguages,
      toLoadNamespaces
    };
  } // 标记加载完成的动作


  loaded(name, err, data) {
    const [lng, ns] = name.split('|');
    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    } // set loaded，如果有错误，则状态为-1，否则为2（加载成功）


    this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

    /*
    组织加载完成的数据，log出来，loaded数据结构为：
    {
      lng1:[ns1,ns2,ns3],
      lng2:[ns1,ns2,ns3]
    }
    */

    const loaded = {}; // callback if ready

    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);
      if (err) q.errors.push(err); // 如果pending队列为空，说明，该队列q已经done

      if (q.pending.length === 0 && !q.done) {
        // only do once per loaded -> this.emit('loaded', q.loaded);
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = [];

          if (q.loaded[l].length) {
            q.loaded[l].forEach(ns => {
              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
            });
          }
        });
        /* eslint no-param-reassign: 0 */
        // 标记为done

        q.done = true;

        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    }); // emit consolidated loaded event

    this.emit('loaded', loaded); // 移除队列中已经完成的请求

    this.queue = this.queue.filter(q => !q.done);
  }
  /* 预加载资源*/

  /*
    options:{
      reload:{boolean} 表示是否重新加载，不使用resource中的资源
    }
  */


  prepareLoading(languages, namespaces, options = {}, callback) {
    // 检测是否有badkend实例，如果没有使用backend实例，则log报错
    if (!this.connectorInstance) {
      this.logger.warn(`No ${this.connectorType} instance was added via ti18n.use. Will not load resources.`);
      return callback && callback({
        isNoConnector: true
      });
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback); // 说明没有待backend发起请求的队列

    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) {
        callback(); // 没有toLoad，也没有pending，现在就执行callback
      }

      return null; // 说明有pending队列，那么pending队列将会触发callbck的trigger,直接返回即可
    } // 说明有需要backend发起请求的资源：toLoad.toLoad
    // 遍历所有的待加载资源，并执行backend加载


    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  } // 加载资源，reload默认为false，执行prepareLoading


  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  } // 重新加载资源，reload为true


  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }

}

/*
  @module BackendConnector.js
  @desc 后端连接器，用于从后端/CDN等获取配置文件
*/

/* function remove(arr, what) {
  let found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}*/

/*
@class Connector
@desc 定义连接器类
*/

class BackendConnector extends Connector {
  constructor(backend, store, services, _options) {
    const options = _options;
    options.connectorType = 'backendConnector';
    super(backend, store, services, options);
    /* if (utils.isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    }*/
    // 赋值

    this.backend = backend; // 后端请求相关实例封装
    // 如果backend有初始化函数，则初始化

    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }

  read(lng, ns, fcName, callback, tried = 0, wait = 350) {
    if (!lng.length) return callback(null, {}); // noting to load
    // fcName为fetchName的意思，就是backend中的method名，默认用read表示fetch后端配置数据

    if (!this.backend || !this.backend[fcName]) {
      this.logger.warn(`No ${this.connectorType} instance was added via ti18n.use. Will not load resources.`);
      callback('no backend instance');
      return;
    }

    return this.backend[fcName](lng, ns, (err, data) => {
      // 5 为 重试次数
      if (err && data
      /* = retryFlag */
      && tried < 5) {
        // 开始重试
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, callback, tried + 1, wait * 2);
        }, wait);
        return;
      } // 回调


      callback && callback(err, data);
    });
  }
  /* eslint consistent-return: 0 */

  /* 预加载资源*/

  /*
    options:{
      reload:{boolean} 表示是否重新加载，不使用resource中的资源
    }
  */
  // 加载1个name，lng|ns


  loadOne(name, prefix = 'backend') {
    const [lng, ns] = name.split('|');
    this.read(lng, ns, 'read', (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);

      if (!err && data) {
        this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      } // 加载成功，则执行标记加载成功动作


      this.loaded(name, err, data);
    });
  } // 如果key缺失，也就是指定的key找不到translation，那么会指定一个回退翻译，ti18n中parseMissingKeyHandler可以指定规则


  saveMissing(languages, namespace, key, fallbackValue, isUpdate, options = {}) {
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      // 调用t的时候，还未init完成返回数据
      this.logger.warn(`did not save key "${key}" for namespace "${namespace}" as the namespace was not yet loaded`, 'This means something IS WRONG in your application setup. You access the t function before ti18n.init / ti18n.loadNamespace / ti18n.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    } // ignore non valid keys


    if (key === undefined || key === null || key === '') return; // 表示创建缺失的key-value到后端中

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null
      /* unused callback */
      , { ...options,
        isUpdate
      });
    } // write to store to avoid resending


    if (!languages || !languages[0]) return; // 存到store中

    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }

}

/*
  @module CacheConnector.js
  @desc 缓存连接器，用于从缓存（比如localStorage等）获取配置文件
*/

/* function remove(arr, what) {
  let found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}*/

/*
@class Connector
@desc 定义连接器类
*/

class CacheConnector extends Connector {
  /*
  expires: 缓存过期时间，过期则不用
  */
  constructor(cache, store, services, _options) {
    const options = _options;
    options.connectorType = 'cacheConnector';

    if (!options.cacheExpires) {
      options.cacheExpires = 86400;
    }

    super(cache, store, services, options);
    /* if (utils.isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    }*/
    // 赋值

    this.cache = cache; // 缓存相关实例封装

    this.cacheExpires = options.expires; // appid必须得要

    if (!options.appid) {
      this.logger.warn('lost param appid in cache connector constructor');
      return;
    }

    this.appid = options.appid; // 如果cache有初始化函数，则初始化

    if (this.cache && this.cache.init) {
      this.cache.init(services, options.cache, options);
    }
  } // 加载1个name，lng|ns


  loadOne(name, prefix = 'cache') {
    const [lng, ns] = name.split('|');
    const cacheKey = [this.appid, lng, ns].join('_');
    this.cache.get(cacheKey, (err, data) => {
      if (err) this.logger.warn(`${prefix} loading namespace ${ns} for language ${lng} failed`, err);

      if (!err && data) {
        this.logger.log(`${prefix} loaded namespace ${ns} for language ${lng}`, data);
      } // 如果本地缓存走不通，则走backend


      if (err) {
        this.services.backendConnector.read(lng, ns, 'read', (err, data) => {
          if (!err) {
            // backend -> cache
            this.writeOne(name, data);
          }

          this.loaded(name, err, data);
        });
        return;
      } // 加载成功或失败都执行loaded


      this.loaded(name, err, data);
    });
  } // 写入一个name到缓存，lng|ns


  writeOne(name, data, callback, prefix = 'cache') {
    const [lng, ns] = name.split('|');
    const cacheKey = [this.appid, lng, ns].join('_');
    this.cache.set({
      cacheKey,
      data,
      expires: this.cacheExpires
    }, (err, data) => {
      if (err) this.logger.warn(`${prefix}writing cache: namespace ${ns} for language ${lng} failed`, err);

      if (!err) {
        this.logger.log(`${prefix}writing cache: namespace ${ns} for language ${lng}`, data);
      } // 回调函数


      callback && callback(err, data);
    });
  }

}

/*
  @module defaults.js
  @desc 定义默认参数的参数名、格式和值
*/

/*
  @method get
  @desc 获取默认参数
*/
function get() {
  return {
    debug: false,
    initImmediate: true,
    appid: '',
    // 应用id，用于访问CDN线上配置的标识符
    ns: ['page1'],
    // 命名空间
    defaultNS: ['page1'],
    // 默认命名空间
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // 表示是否部分资源（lng）从SDK传入，部分资源（lng）从其它地方获取（connector）
    saveMissing: false,
    // enable to send missing values
    // (only useful on initial development, or when keeping code as source of truth)
    updateMissing: false,
    // enable to update default values if different from translated value
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    postProcessPassResolved: false,
    // pass resolved object into 'options.i18nResolved' for postprocessor
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      let ret = {};

      if (typeof args[1] === 'object') {
        [, ret] = args;
      }

      if (typeof args[1] === 'string') {
        [, ret.defaultValue] = args;
      }

      if (typeof args[2] === 'string') {
        [,, ret.tDescription] = args;
      }

      if (typeof args[2] === 'object' || typeof args[3] === 'object') {
        const options = args[3] || args[2];
        Object.keys(options).forEach(key => {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    // 插值相关的定义格式
    interpolation: {
      escapeValue: true,
      format: (value
      /* , format, lng, options*/
      ) => value,
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',

      /*
        object that can have values to interpolate on - extends passed in interpolation data
      */
      // defaultVariables: undefined
      maxReplaces: 1000 // max replaces to prevent endless loop

    },
    // key来源
    keyFromOptions: {
      keyFrom: 'key',
      // 默认：key，表示t函数通过key翻译，可选:word，表示t函数通过word(词条)翻译
      wordLng: '' // from为word的时候可用，表示word所属的源语言

    }
  };
}
/*
  @method transformOptions
  @desc 格式化参数，将入参转换为标准的程序可接收，可处理的格式
*/

/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // 格式化相关参数，如果传入的是string，则转换成array
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

/*
@module ti18n
@desc ti18n 入口js，主要是初始化i18n，各类service的安装，初始化工作等
*/

function noop() {}

class I18n extends EventEmitter {
  // 构造函数，用于构造一个ti18n 实例的入口，包括merge 参数，初始化各类service，加载初始化语言包资源等

  /*
    options：自定义的参数，会merge到默认参数中
    callback：构造完成后的回调函数，此时，语言包资源应该已经加载完成
  */
  constructor(options = {}, callback) {
    super();

    if (isIE10) {
      EventEmitter.call(this); // <=IE10 fix (unable to call parent constructor)
    }

    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };

    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      } // 如果是立即初始化，则直接执行init函数


      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }

  init(_options = {}, _callback) {
    let options = _options;
    let callback = _callback;

    if (typeof options === 'function') {
      callback = options;
      options = {};
    } // merge options，默认参数-》已有参数（如果不是第一次init会有值）->传入的自定义参数


    this.options = { ...get(),
      ...this.options,
      ...transformOptions(options)
    }; // 插值格式，函数类型

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop; // 返回一个实例，如果如参为function，则实例化返回

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    } // init services
    // 如果isClone=true,则对service不初始化,表示当前实例为clone过来的


    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      } // 初始化languageUtils


      const lu = new LanguageUtil(this.options); // 初始化store

      /*
        this.options.resources 表示默认传入的资源数据
      */

      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu; // 复数规则处理器

      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }); // 日期翻译处理器

      s.dateResolver = new DateResolver(this.options); // 插值处理机制

      s.interpolator = new Interpolator(this.options); // utils

      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }; // 后端资源请求连接器

      s.backendConnector = new BackendConnector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // add-i18nCore--start
      // 增加缓存资源请求链接器

      s.cacheConnector = new CacheConnector(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options); // add-i18nCore--end
      // pipe events from backendConnector

      s.backendConnector.on('*', (event, ...args) => {
        this.emit(event, ...args);
      }); // 语言跟踪器

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      } // i18n 格式化模块


      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      } // 核心翻译实例


      this.translator = new Translator(this.services, this.options); // pipe events from translator

      this.translator.on('*', (event, ...args) => {
        this.emit(event, ...args);
      }); // 第三方模块的初始化

      this.modules.external.forEach(m => {
        if (m.init) {
          m.init(this);
        }
      });
    } // 程序无法确定入口语言，抛出log异常


    if (!this.modules.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    } // append api


    const storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage']; // 将ResourceStore实例上的部分methods挂载到i18n上，方便调用

    storeApi.forEach(fcName => {
      this[fcName] = (...args) => this.store[fcName](...args);
    }); // 构建promise返回

    const deferred = defer();

    const load = () => {
      // 切换到入口语言
      this.changeLanguage(this.options.lng, (err, t) => {
        // 入口语言切换完毕，才能标记初始化成功
        this.isInitialized = true;
        this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return deferred;
  }
  /* eslint consistent-return: 0 */

  /*
    language如果不传，则language为this.language
  */


  loadResources(language, callback = noop) {
    let usedCallback = callback;
    const usedLng = typeof language === 'string' ? language : this.language;
    if (typeof language === 'function') usedCallback = language;

    if (!this.options.resources || this.options.partialBundledLanguages) {
      // cimode下，不加载资源
      if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback(); // avoid loading resources for cimode

      const toLoad = [];

      const append = lng => {
        if (!lng) return; // 标准化语言

        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!usedLng) {
        // at least load fallbacks in this case
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      } // 表示定义了预加载到语言资源


      if (this.options.preload) {
        this.options.preload.forEach(l => append(l));
      } // 这里调用cacheConnector/backendConnector去后端加载需要的资源

      /*
        toLoad为需要加载的语言数组lng
        this.options.ns为命名空间
      */
      // add-i18nCore--start
      // 优先判断缓存


      this.services.cacheConnector.load(toLoad, this.options.ns, (err, data) => {
        // 判断是否命中缓存
        if (err) {
          // 没有命中，则走后端请求
          this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
        } else {
          usedCallback(null, data);
        }
      }); // add-i18nCore--end
    } else {
      usedCallback(null);
    }
  } // 重新加载资源


  reloadResources(_lngs, _ns, _callback) {
    let lngs = _lngs;
    let ns = _ns;
    let callback = _callback;
    const deferred = defer();
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

      callback(err);
    });
    return deferred;
  } // 加载自定义模块，服务，第三方模块等


  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to ti18n.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to ti18n.use()');

    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    } // add-i18nCore--start
    // 加载cache模块


    if (module.type === 'cache') {
      this.modules.cache = module;
    } // add-i18nCore--end


    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    } // 处理器模块


    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    } // 第三方模块


    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  } // 切换语言操作


  changeLanguage(lng, callback) {
    this.isLanguageChangingTo = lng;
    const deferred = defer(); // 开始触发语言改变事件

    this.emit('languageChanging', lng);

    const done = (err, l) => {
      if (l) {
        this.language = l;
        this.languages = this.services.languageUtils.toResolveHierarchy(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined; // 语言改变完成

        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }

      deferred.resolve((...args) => this.t(...args));
      if (callback) callback(err, (...args) => this.t(...args));
    };

    const setLng = l => {
      if (l) {
        if (!this.language) {
          this.language = l;
          this.languages = this.services.languageUtils.toResolveHierarchy(l);
        }

        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(l);
      }

      this.loadResources(l, err => {
        done(err, l);
      });
    }; // lng没有值，采用语言跟踪器，语言跟踪器-同步方式


    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      // lng没有值，采用语言跟踪器，语言跟踪器-异步方式
      this.services.languageDetector.detect(setLng);
    } else {
      // lng有值
      setLng(lng);
    }

    return deferred;
  } // 固定lng和ns的t函数,一个闭包函数

  /*
  比如：const T_EN=ti18n.getFixedT('en','translate');
  console.log(T_EN('page1.login'));
  */


  getFixedT(lng, ns) {
    const fixedT = (key, opts, ...rest) => {
      let options;

      if (typeof opts !== 'object') {
        options = this.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = { ...opts
        };
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return this.t(key, options);
    };

    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }

    fixedT.ns = ns;
    return fixedT;
  } // 核心函数，translator中的translate方法


  t(...args) {
    return this.translator && this.translator.translate(...args);
  } // 核心函数，translator中的translateWord方法


  tw(...args) {
    return this.translator && this.translator.translateWord(...args);
  } // changeKeyFrom


  changeKeyFrom(...args) {
    return this.translator && this.translator.changeKeyFrom(...args);
  } // translator中的exists方法


  exists(...args) {
    return this.translator && this.translator.exists(...args);
  } // translator中的translateDate方法


  d(date, config) {
    if (config && config.language && config.language !== this.language) {
      this.changeLanguage(config.language);
    }

    return this.translator && this.translator.translateDate(date, config);
  } // 设置默认ns，options中defaultNS参数


  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  } // 判断指定ns是否已经加载


  hasLoadedNamespace(_ns) {
    const ns = _ns; // i18n未初始化，报错

    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: ti18n was not initialized', this.languages);
      return false;
    } // 未指定语言


    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }

    const lng = this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1]; // we're in cimode so this shall pass

    if (lng.toLowerCase() === 'cimode') return true; // 判断指定lng|ns 是否已经加载过（加载失败也算）

    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      /*
      cache
      const loadCacheState = this.services.cacheConnector.state[`${l}|${n}`];
      */

      return loadState === -1 || loadState === 2
      /* || loadCacheState === 2*/
      ;
    }; // loaded -> SUCCESS


    if (this.hasResourceBundle(lng, ns)) return true; // were not loading at all -> SEMI SUCCESS

    if (!this.services.backendConnector.backend) return true; // failed loading ns - but at least fallback is not pending -> SEMI SUCCESS

    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  } // 加载命名空间资源


  loadNamespaces(_ns, callback) {
    let ns = _ns;
    const deferred = defer();

    if (!this.options.ns) {
      callback && callback();
      return Promise.resolve();
    }

    if (typeof ns === 'string') ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  } // 加载语言资源


  loadLanguages(_lngs, callback) {
    let lngs = _lngs;
    const deferred = defer();
    if (typeof lngs === 'string') lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0); // Exit early if all given languages are already preloaded

    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }

  dir(_lng) {
    let lng = _lng;
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  }
  /* eslint class-methods-use-this: 0 */
  // 创建一个新的I18n的实例


  createInstance(options = {}, callback) {
    return new I18n(options, callback);
  } // 从当前实例clone一个新的实例出来


  cloneInstance(options = {}, callback = noop) {
    const mergedOptions = { ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = { ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    clone.translator = new Translator(clone.services, clone.options);
    clone.translator.on('*', (event, ...args) => {
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }

}

var ti18n = new I18n();

// link到ti18n.js

export default ti18n;
